import { Component, Injector, ViewChild } from '@angular/core';
import moment from 'moment';
import { ModalDirective } from 'ngx-bootstrap/modal';
import { AppComponentBase } from 'src/shared/common/app-component-base';
import { AuditLogServiceProxy, EntityChangeListDto, EntityPropertyChangeDto } from 'src/shared/service-proxies/service-proxies';

/* eslint-disable @typescript-eslint/no-this-alias */
@Component({ standalone: false, selector: 'entityChangeDetailModal', templateUrl: './entity-change-detail-modal.component.html' })
export class EntityChangeDetailModalComponent extends AppComponentBase {
  @ViewChild('entityChangeDetailModal', { static: true })
  modal: ModalDirective;

  active = false;
  entityPropertyChanges: EntityPropertyChangeDto[];
  entityChange: EntityChangeListDto;

  constructor(
    injector: Injector,
    private _auditLogService: AuditLogServiceProxy,
  ) {
    super(injector);
  }

  getPropertyChangeValue(propertyChangeValue, propertyTypeFullName) {
    if (!propertyChangeValue) {
      return propertyChangeValue;
    }
    propertyChangeValue = propertyChangeValue.replace(/^['"]+/g, '').replace(/['"]+$/g, '');
    if (this.isDate(propertyChangeValue, propertyTypeFullName)) {
      const dateString = moment(propertyChangeValue).format('YYYY-MM-DD HH:mm:ss');
      return dateString;
    }

    if (propertyChangeValue === 'null') {
      return '';
    }

    return propertyChangeValue;
  }

  isDate(date, propertyTypeFullName): boolean {
    return propertyTypeFullName.includes('DateTime') && !isNaN(Date.parse(date).valueOf());
  }

  isUpdated(): boolean {
    return this.entityChange.changeTypeName == 'Updated';
  }

  show(record: EntityChangeListDto): void {
    const self = this;
    self.active = true;
    self.entityChange = record;

    this._auditLogService.getEntityPropertyChanges(record.id).subscribe(result => {
      self.entityPropertyChanges = result;
    });

    self.modal.show();
  }

  close(): void {
    this.active = false;
    this.modal.hide();
  }
}
